import { Directive, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
    selector: '[asciiOnly]',
    standalone: false
})
export class AsciiOnlyDirective {
  constructor(private ngControl: NgControl) {}

  @HostListener('input', ['$event']) onInputChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    const filteredValue = input.value.replace(/[^\x00-\x7F]/g, '');
    this.ngControl.control?.setValue(filteredValue);
  }
}